import { gtmEventType, inquiryType } from '@Components/Utilities/SandhillsConstants';
import { useRef, useState } from 'react';
import { gtmPushEvent } from '@Components/Utilities/SandhillsUtility';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import TranslationText from '@Components/Utilities/TranslationText';
import ConditionalWrapper from '@Components/Utilities/ConditionalWrapper';
import translator from '@Components/Utilities/Translator';

const FBODirectoryFuelTable = loadable(() => import('@Components/DealerDirectory/FBODirectoryFuelTable'));

const FBODirectoryListing = (props) => {

    const ref = useRef();
    const [showFuelPrices, setShowFuelPrices] = useState(false);
    const windowSize = useWindowSize();

    const openEmailModal = () => props.openEmailModal(inquiryType.Email, {
        DealerGroupID: props.DealerGroupID,
        DealerCRMID: props.DealerCRMID,
        BranchName: props.BranchName,
        Subject: props.EmailSubject,
        ref: ref
    });

    const fboButtons = (
        <>
            <div className='dealer-listing-row button-container'>
                {props.InventoryUrls && props.InventoryUrls.length > 0 &&
                    props.InventoryUrls.map((item, index) =>
                        <a className={'inventory-button ' + item.CssClass} href={item.Url} >{item.DisplayText}</a>
                    )
                }
                {props.ShowEmailButton &&
                    <button ref={ref} key={props.LocationID} className='ts-button dealer-contact-button dealer-title-text des-email-seller send-email' onClick={() => openEmailModal()}>
                        <i className='far fa-envelope' />
                        <TranslationText tKey='sandhills.sendemail' />
                    </button>
                }
                {props.FuelPrices && props.FuelPrices.length > 0 &&
                    <button className='ts-button dealer-contact-button dealer-title-text' onClick={() => setShowFuelPrices(!showFuelPrices)}>
                        <i className='fa-solid fa-gas-pump' />
                        Fuel Prices
                    </button>
                }
                {(props.ShowEmployeeOnlyInfo && props.CrmLink) &&
                    <a href={props.CrmLink} className="dealer-contact-button btn--pub-reversed" target="_blank" aria-label={"Edit in CRM (" + translator.translate('sandhills.opensinanewtab') + ")"}>
                        Edit in CRM
                    </a>
                }
            </div>
        </>
    );

    return (
        <div className='fbo-directory-listing'>
            <input type='hidden' name='LocationID' value={props.LocationID} />
            <div className='dealer-listing-row'>
                <div className='fbo-title'>
                    {props.InventoryUrls && props.InventoryUrls.length > 0 ?
                        <strong><a href={props.InventoryUrls[0].Url} className='dealer-title-text'>{props.DealerName}</a></strong>
                        :
                        <strong><span className='dealer-title-text'>{props.DealerName}</span></strong>
                    }
                    {props.InventoryManagementURL &&
                        <a href={props.InventoryManagementURL} className='dealer-data-text' target='_blank' aria-label={"View in Inventory Management (" + translator.translate('sandhills.opensinanewtab') + ")"}>View in Inventory Management</a>
                    }
                </div>
                {props.DealerLogoURL && windowSize.isMobile &&
                    <div className="dealer-logo-container-mobile">
                        <img src={props.DealerLogoURL} className='dealer-logo' alt='' rel={props.IsFirst ? 'preload' : ''} loading={props.IsFirst ? '' : 'lazy'} />
                    </div>
                }
                {props.PremierFBO &&
                    <div className="premier-fbo">
                        <i class="fas fa-star"></i>
                        <TranslationText tKey='sandhills.tradesites.mvc.premierfbo' />
                    </div>
                }
                <div className='dealer-listing-full'>
                    <div className='dealer-contact-info'>
                        <strong><TranslationText tKey='sandhills.tradepubwebsite.mvc.contactinfo' />:</strong>
                        {props.ShowStreetAddress &&
                            <div className='dealer-data-text'>{props.DealerAddress}</div>
                        }
                        <div className='dealer-data-text'>{props.DealerCityStatePostal}</div>
                        <div className='dealer-phone'>
                            <TranslationText tKey='sandhills.phone' />: <a href={'tel:' + props.UnformattedDealerPhoneNumber} onClick={() => gtmPushEvent(gtmEventType.call)}>{props.FormattedDealerPhoneNumber}</a>
                        </div>
                    </div>
                    {showFuelPrices &&
                        <div className='fuel-table-wrapper'>
                            <FBODirectoryFuelTable FuelPrices={props.FuelPrices} />
                        </div>
                    }
                </div>
            </div>
            {props.DealerLogoURL && !windowSize.isMobile &&
                <div className="dealer-logo-container">
                    <img src={props.DealerLogoURL} className='dealer-logo' alt='' rel={props.IsFirst ? 'preload' : ''} loading={props.IsFirst ? '' : 'lazy'} />
                </div>
            }
            <div className='fbo-button-container'>
                {fboButtons}
            </div>
        </div>
    );
};

export default FBODirectoryListing;